import { useEffect } from "react";
import { useFormikContext } from "formik";
var GroupMiddlewareListener = function (_a) {
    var active = _a.active, groupId = _a.groupId, cartAddInput = _a.cartAddInput, submitCartAddInput = _a.submitCartAddInput;
    var formikContext = useFormikContext();
    useEffect(function () {
        if (active && groupId && cartAddInput && !formikContext.isSubmitting) {
            formikContext.setSubmitting(true);
            submitCartAddInput(cartAddInput, formikContext, formikContext.status.setGlobalError);
        }
    }, [groupId]);
    return null;
};
export default GroupMiddlewareListener;
